import React from 'react';
import './AccountDeletion.css';

const AccountDeletion = () => {
    return (
        <div className="account-deletion-container">
            <div className="account-deletion-content">
                <h1>계정 및 데이터 삭제 안내</h1>
                
                <section className="deletion-section">
                    <p className="intro">
                        묘원365-공원 묘지 길 안내 앱 사용자는 언제든지 계정 및 개인정보 삭제를 요청할 수 있습니다. 
                        아래 안내에 따라 계정 삭제를 진행하실 수 있습니다.
                    </p>
                </section>

                <section className="deletion-section">
                    <h2>앱 내에서 계정 삭제</h2>
                    <p>앱 내에서 직접 계정을 삭제하실 수 있습니다.</p>
                    
                    <div className="steps-container">
                        <div className="step-item">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3>앱 실행 및 로그인</h3>
                                <p>묘지 관리 앱을 실행하고 로그인합니다.</p>
                            </div>
                        </div>

                        <div className="step-item">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3>마이페이지 접속</h3>
                                <p>하단 메뉴에서 '마이페이지' 또는 '내 정보'를 선택합니다.</p>
                            </div>
                        </div>

                        <div className="step-item">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3>설정 메뉴 선택</h3>
                                <p>마이페이지에서 '설정' 또는 '계정 관리' 메뉴를 선택합니다.</p>
                            </div>
                        </div>

                        <div className="step-item">
                            <div className="step-number">4</div>
                            <div className="step-content">
                                <h3>회원 탈퇴 선택</h3>
                                <p>'회원 탈퇴' 또는 '계정 삭제' 버튼을 선택합니다.</p>
                            </div>
                        </div>

                        <div className="step-item">
                            <div className="step-number">5</div>
                            <div className="step-content">
                                <h3>탈퇴 확인</h3>
                                <p>안내 사항을 확인하고 '탈퇴하기' 버튼을 눌러 완료합니다.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="deletion-section">
                    <h2>이메일을 통한 계정 삭제 요청</h2>
                    <p>앱에 접근할 수 없거나 직접 삭제가 어려운 경우, 이메일로 요청하실 수 있습니다.</p>
                    
                    <div className="email-request-box">
                        <h3>이메일 요청 방법</h3>
                        <div className="request-details">
                            <div className="detail-item">
                                <strong>받는 사람:</strong>
                                <span className="email-address">aonelink20151111@gmail.com</span>
                            </div>
                            <div className="detail-item">
                                <strong>제목:</strong>
                                <span>[계정 삭제 요청] 회원 탈퇴 신청</span>
                            </div>
                            <div className="detail-item">
                                <strong>필수 포함 정보:</strong>
                                <ul>
                                    <li>가입 시 사용한 휴대폰 번호</li>
                                    <li>가입 시 등록한 성명</li>
                                    <li>탈퇴 사유 (선택사항)</li>
                                </ul>
                            </div>
                        </div>
                        
                        <div className="email-template">
                            <h4>이메일 작성 예시</h4>
                            <div className="template-box">
                                <p><strong>제목:</strong> [계정 삭제 요청] 회원 탈퇴 신청</p>
                                <p><strong>본문:</strong></p>
                                <div className="template-content">
                                    안녕하세요.<br/>
                                    묘지 관리 앱 계정 삭제를 요청합니다.<br/><br/>
                                    
                                    - 가입 휴대폰 번호: 010-XXXX-XXXX<br/>
                                    - 성명: 홍길동<br/>
                                    - 탈퇴 사유: (선택사항)<br/><br/>
                                    
                                    계정 및 관련 개인정보의 삭제를 요청드립니다.<br/>
                                    감사합니다.
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="deletion-section">
                    <h2>처리 기간 및 절차</h2>
                    
                    <div className="process-info">
                        <div className="process-item">
                            <div className="process-icon">⏱️</div>
                            <div className="process-text">
                                <h3>처리 기간</h3>
                                <p>요청 접수 후 <strong>영업일 기준 3일 이내</strong>에 처리됩니다.</p>
                            </div>
                        </div>

                        <div className="process-item">
                            <div className="process-icon">✅</div>
                            <div className="process-text">
                                <h3>완료 통지</h3>
                                <p>삭제 완료 시 등록된 휴대폰 번호 또는 이메일로 <strong>완료 통지</strong>를 발송합니다.</p>
                            </div>
                        </div>

                        <div className="process-item">
                            <div className="process-icon">📞</div>
                            <div className="process-text">
                                <h3>본인 확인</h3>
                                <p>이메일 요청 시 본인 확인을 위해 <strong>추가 정보를 요청</strong>할 수 있습니다.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="deletion-section">
                    <h2>삭제되는 정보</h2>
                    <p>계정 삭제 시 다음 정보가 영구적으로 삭제됩니다.</p>
                    
                    <div className="deleted-data-box">
                        <h3>삭제 항목</h3>
                        <ul className="deleted-list">
                            <li>
                                <span className="list-icon">🗑️</span>
                                <div>
                                    <strong>계정 정보</strong>
                                    <p>성명, 휴대폰번호, 생년월일, 본인인증정보(CI, DI)</p>
                                </div>
                            </li>
                            <li>
                                <span className="list-icon">📍</span>
                                <div>
                                    <strong>서비스 이용 기록</strong>
                                    <p>방문 기록, 위치정보, 앱 사용 내역</p>
                                </div>
                            </li>
                            <li>
                                <span className="list-icon">📝</span>
                                <div>
                                    <strong>앱 활동 정보</strong>
                                    <p>검색 기록, 즐겨찾기, 설정 정보</p>
                                </div>
                            </li>
                            <li>
                                <span className="list-icon">🔐</span>
                                <div>
                                    <strong>인증 정보</strong>
                                    <p>로그인 토큰, 인증 코드 등</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </section>

                <section className="deletion-section">
                    <h2>법령에 따른 정보 보관</h2>
                    <p>관계 법령에 따라 일부 정보는 아래 기간 동안 보관될 수 있습니다.</p>
                    
                    <div className="retention-box">
                        <div className="retention-item">
                            <strong>계약 또는 청약철회 등에 관한 기록</strong>
                            <span className="retention-period">5년</span>
                        </div>
                        <div className="retention-item">
                            <strong>대금결제 및 재화 등의 공급에 관한 기록</strong>
                            <span className="retention-period">5년</span>
                        </div>
                        <div className="retention-item">
                            <strong>소비자 불만 또는 분쟁처리에 관한 기록</strong>
                            <span className="retention-period">3년</span>
                        </div>
                        <div className="retention-item">
                            <strong>서비스 방문 기록</strong>
                            <span className="retention-period">3개월</span>
                        </div>
                    </div>
                    
                    <p className="retention-note">
                        ※ 위 정보는 법령에서 정한 기간 동안만 보관되며, 보관 기간 경과 후 지체 없이 파기됩니다.
                    </p>
                </section>

                <section className="deletion-section warning-section">
                    <h2>⚠️ 주의사항</h2>
                    <div className="warning-box">
                        <ul className="warning-list">
                            <li>
                                <strong>삭제는 즉시 처리되며 복구가 불가능합니다.</strong>
                                <p>계정 삭제 후에는 동일한 휴대폰 번호로 재가입이 가능하나, 이전 데이터는 복구되지 않습니다.</p>
                            </li>
                            <li>
                                <strong>진행 중인 거래나 서비스가 있는 경우</strong>
                                <p>모든 거래 및 서비스를 종료한 후 계정 삭제를 진행하시기 바랍니다.</p>
                            </li>
                            <li>
                                <strong>관련 계약이 있는 경우</strong>
                                <p>묘지 계약 등 유효한 계약이 있는 경우, 계약 관련 정보는 법령에 따라 별도 관리됩니다.</p>
                            </li>
                        </ul>
                    </div>
                </section>

                <section className="deletion-section">
                    <h2>문의하기</h2>
                    <p>계정 삭제와 관련하여 궁금한 사항이 있으시면 아래로 문의해주세요.</p>
                    
                    <div className="contact-box">
                        <div className="contact-item">
                            <div className="contact-icon">📧</div>
                            <div className="contact-info">
                                <strong>이메일</strong>
                                <a href="mailto:support@a1link.co.kr">aonelink20151111@gmail.com</a>
                            </div>
                        </div>
                        <div className="contact-item">
                            <div className="contact-icon">📞</div>
                            <div className="contact-info">
                                <strong>고객센터</strong>
                                <p>영업일 기준 09:00 ~ 18:00</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="deletion-section">
                    <h2>관련 정책</h2>
                    <div className="policy-links">
                        <a href="/privacy-policy" className="policy-link">
                            📄 개인정보처리방침 보기
                        </a>
                    </div>
                </section>

                <footer className="deletion-footer">
                    <p>주식회사 에이원링크</p>
                    <p className="footer-date">최종 업데이트: 2026년 2월 12일</p>
                </footer>
            </div>
        </div>
    );
};

export default AccountDeletion;

